import { TableHead } from "@mui/material";
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { ChangeCursor } from "./MiscFunctions";
import { Card, Col, Container, Row } from "react-bootstrap";
function PatientDetails() {
  const [patientDetails, setPatientDetails] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const history = useHistory();
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    const res = [];
    if (headers.length !== null) {
      if (Token()) {
        axios
          .get(
            `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
            {
              headers: headers,
            }
          )
          .then((res) => {
            // console.log(res.data)
            setPatientDetails(res.data?.data);
          });
      }
    }
  }, [authToken]);
  const navigate = (e) => {
    history.push(`/${e.target.id}`);
  };
  return (
    <div>
      <h1 style={{ paddingLeft: "35%" }}>Patient Details</h1>
      <Container>
        <Row
          style={{
            marginTop: "2%",
            marginbottom: "2%",
            paddingBottom: "2%",
            width: "125%",
            marginLeft: "-10%",
          }}
        >
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="register_patient"
              style={{
                width: "100%",
                marginLeft: "-30%",
                height: "100%",
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex" }} id="register_patient">
                <img
                  id="register_patient"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="register_patient"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  Register Patient
                </h6>
              </div>
            </Card>
          </Col>
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="care_context"
              style={{
                width: "140%",
                marginLeft: "-35%",
                height: "100%",
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex" }} id="care_context">
                <img
                  src="/img/success-black-check-mark.svg"
                  id="care_context"
                  alt=""
                />
                <h6
                  id="care_context"
                  style={{ paddingTop: "8%", whiteSpace: "nowrap" }}
                >
                  Create & Link Visit Purpose
                </h6>
              </div>
            </Card>
          </Col>
          {sessionStorage.getItem("subscription_type") !== undefined &&
          sessionStorage.getItem("subscription_type") !== null &&
          sessionStorage
            .getItem("subscription_type")
            .includes("Connector/Adaptor") ? (
            []
          ) : (
            <Col>
              <Card
                onClick={(e) => navigate(e)}
                id="upload_report"
                style={{ width: "100%", height: "100%", cursor: "pointer" }}
              >
                <div style={{ display: "flex" }} id="upload_report">
                  <img
                    id="upload_report"
                    src="/img/success-black-check-mark.svg"
                    alt=""
                  />
                  <h6
                    id="upload_report"
                    style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                  >
                    Upload Report
                  </h6>
                </div>
              </Card>
            </Col>
          )}
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="consent"
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            >
              <div style={{ display: "flex" }} id="consent">
                <img
                  id="consent"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="consent"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  EHR Data Access
                </h6>
              </div>
            </Card>
          </Col>
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="admin_services"
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            >
              <div style={{ display: "flex" }} id="admin_services">
                <img
                  id="admin_services"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="admin_services"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  Admin Services
                </h6>
              </div>
            </Card>
          </Col>
          <Col>
            <Card
              onClick={(e) => navigate(e)}
              id="scan_qr"
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
            >
              <div style={{ display: "flex" }} id="scan_qr">
                <img
                  id="scan_qr"
                  src="/img/success-black-check-mark.svg"
                  alt=""
                />
                <h6
                  id="scan_qr"
                  style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                >
                  QR
                </h6>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <Table
        bordered
        responsive
        size="lg"
        style={{ marginLeft: "30%", width: "25%" }}
      >
        <TableHead
          style={{
            display: "grid",
            fontWeight: "bold",
            gridTemplateColumns: "145px 145px 145px 170px",
          }}
        >
          <th>Patient Id</th>
          <th>Name</th>
          <th>ABHA Address</th>
          <th>ABHA No</th>
        </TableHead>
        <tbody>
          {patientDetails !== undefined
            ? patientDetails.map((item, index) => (
                <td
                  style={{
                    display: "grid",
                    gridTemplateColumns: "145px 145px 145px 145px",
                  }}
                >
                  <tr>{item.patient_id}</tr>
                  <tr>{item.name}</tr>
                  <tr>{item.abha_id}</tr>
                  <tr>{item.abha_no !== null ? item.abha_no : ""}</tr>
                </td>
              ))
            : []}
        </tbody>
      </Table>
    </div>
  );
}

export default PatientDetails;
